const {h, render, Component} = require('preact');
const ClaimContainer = require('./claim/claim')
const ClaimsView = require('../../views/gplus/claims')
const SupportAPIHelper = require('../../../../../support/frontend/helpers/API')
const NoItemsView = require('../../views/common/no_items')
const ErrorView = require('../main/error')

class Claims extends Component {
  constructor() {
    super();
    this.createClaimsTable = this.createClaimsTable.bind(this);
    this.setState({isLoadingInProgress: true, noClaimsFound: false});
  }

  componentWillMount() {
    let claimsUrl = `${Groupon.Utils.getConfigFromDom().SUPPORTBASEURL}/claims`;
    let errorCb = (response) => {
      this.setState({claims: null, isLoadingInProgress: false, 'isFailure': true});
    }
    let successCb = (response) => {
      if (response && response.claims && response.claims.length === 0){
        this.setState({noClaimsFound: true});
      }
      else if (response && response.claims.length > 0) {
        this.setState({claims: response.claims, length: response.claims.length, isLoadingInProgress: false});
      }
    }
    this.setState({isLoadingInProgress: true})
    SupportAPIHelper.get(claimsUrl, null, successCb, errorCb, false);
  }

  createClaimsTable() {
    let table = [], rows = 2, columns = 2, currentIndex;
    if (this.state.claims) {
      for (let row = 0; row < rows; row++) {
        let children = []
        for (let col = 0; col < columns; col++) {
          currentIndex = columns * row + col
          if (currentIndex < this.state.claims.length) {
            children.push(<ClaimContainer item={this.state.claims[currentIndex]}/>)
          }
        }
        table.push(<tr class="claimTableRow">{children}</tr>)
      }
    }
    return table;
  }

  render() {
    if (this.state.noClaimsFound){
      return <NoItemsView noClaimsFound = {this.state.noClaimsFound} />;
    }
    else if (this.state.isFailure) {
      return <ErrorView/>
    }
    else{
      return (
        <ClaimsView
          page='landing'
          claimsTable={this.createClaimsTable.bind(this)}
          length={this.state.length} isLoadingInProgress={this.state.isLoadingInProgress}
        />
      );
    }

  }
}

module.exports = Claims
